"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.makeGetProductComparisonState = void 0;
const reselect_1 = require("reselect");
const getProductComparison = (state) => state.productComparison;
const makeGetProductComparisonState = () => (0, reselect_1.createSelector)(getProductComparison, (products) => products);
exports.makeGetProductComparisonState = makeGetProductComparisonState;
